import CloseIcon from "@mui/icons-material/Close";
import { requestPaymentWithdraw } from "../../../ApiServices/ApiServices";
import { FaWallet, FaCheckCircle } from "react-icons/fa";
import { getEmail } from "../../../DecodeToken/DecodeToken";
import { handleError} from "../../../Utils";
import { useState } from "react";
import CodeQueueSpinner from "../../../Utils";

const WithdrawRequest = ({
  setWithdrawRequestVisible,
  balanceToWithdraw,
  name,
  getPaymentDetails,
}) => {
  const [paymentInitiatedPopUp, setPaymentInitiatedPopUp] = useState(false);
  const [confirmatinMessage, setConfirmationMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const email = getEmail();

  const netAmount = Math.floor(balanceToWithdraw * 0.75);

  const handleConfirmWithdraw = async() => {
    try {
      setLoading(true);
      const response = await requestPaymentWithdraw(name);
      setConfirmationMessage(response.message);
      setTimeout(() => {
        setPaymentInitiatedPopUp(!paymentInitiatedPopUp);
      }, 2000);
    } catch (error) {
     return handleError(error?.response?.data?.message); 
    }
  };

  const handleClosePopUps = ()=>{
    setWithdrawRequestVisible(false);
    setPaymentInitiatedPopUp(!paymentInitiatedPopUp);
    getPaymentDetails();
  }

  return (
    <div>
      {/* Withdraw Earnings Popup */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-lg w-full max-w-md p-6">
          <div className="flex">
            <div className="bg-green-200 p-4 rounded-l-lg w-1/3 flex items-center justify-center">
              <FaWallet className="text-white text-4xl" />
            </div>
            {/* Right Column */}
            <div className="p-4 w-2/3 relative">
              <div
                className="absolute top-2 right-2 cursor-pointer"
                onClick={() => setWithdrawRequestVisible(false)}
              >
                <CloseIcon />
              </div>
              <div className="text-2xl text-gray-700 font-bold mb-2">
                Withdraw Earnings
              </div>
              <div className="text-sm text-gray-600 mb-4">
                The transaction will be done from{" "}
                <b className="font-semibold text-gray-700">
                  Codequeue Technologies
                </b>
                &nbsp; and will reflect in your bank account instantly.
              </div>
              {/* Amount Container */}
              <div className="border-dotted border-2 border-gray-300 p-4 mb-4 rounded-lg">
                <div className="flex justify-between items-center text-gray-600">
                  <span className="text-sm">Amount</span>
                  <div className="flex items-center">
                    <span className="text-sm font-semibold mr-2">₹{netAmount}</span>
                    <div className="relative group">
                      <span className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-200 text-gray-700 text-xs font-bold cursor-pointer">
                        i
                      </span>
                      <div
                        className="absolute left-6 bottom-full mb-2 z-20 hidden group-hover:block bg-black text-white text-xs rounded px-2 py-2 whitespace-normal shadow-lg"
                        style={{ width: "180px" }}
                      >
                        Earnings after deducting 25% CodeQueue commission
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Withdraw Button */}
              <button
                disabled={loading}
                className={`bg-black text-white font-bold py-2 px-6 rounded-lg w-full flex items-center justify-center ${loading ? "cursor-not-allowed opacity-70" : ""}`}
                onClick={handleConfirmWithdraw}
              >
                {loading ? (
                  <span className="mr-2">
                    <CodeQueueSpinner size={20} color="#fff" />
                  </span>
                ) : null}
                Confirm Withdraw
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* Payment Initiated Confirmation Popup */}
      {paymentInitiatedPopUp && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg w-full max-w-sm">
            <div className="text-center">
              <div className="flex items-center justify-center">
                <FaCheckCircle className="text-blue-500 text-5xl mb-4" />
              </div>

              <div className="text-lg text-gray-800 font-bold">
                {confirmatinMessage}
              </div>
              <div className="text-sm text-gray-600 mt-2">
                Funds are on the way to your account. In case of any issues,
                reach out at <br />
                <b>Support@codequeue.in</b>
              </div>
              <div className="mt-4">
                <button onClick={handleClosePopUps} className="bg-black text-white font-bold py-2 px-8 rounded-lg w-[200px]">
                  Okay
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default WithdrawRequest;
